import IMAGES from '../public/assets/img/index';

export const FORMSDATA={
    HOME:{
        testimonial:{
            heading:'Gain insights from our success stories',
            subheading:'Our success stories will help you assess the business impact created by Credlix for our customers.',
            image:IMAGES.HOMEIMG.testimonialReadmore
        },
        testimonial_es:{
            heading:'Obtenga información de nuestras historias de éxito',
            subheading:'Nuestras historias de éxito lo ayudarán a evaluar el impacto comercial creado por Credlix para nuestros clientes.',
            image:IMAGES.HOMEIMG.testimonialReadmore
        },
        fiveSecondPopup:{
            heading:'Are you looking for',
            subheading:'immediate working capital?',
            image:IMAGES.HOMEIMG.aylf_popupimg
        }
    },
    SIGNUP_FOR_DEMO:{
        requestdemo:{
            heading:'Sign up for a personalized demo',
            subheading:"Learn how Credlix's data-driven and intuitive digital experience can help you get access to working capital.",
            image:IMAGES.REQUESTDEMO.requestDemoImage
        },
    },
    SIGNUP_FOR_DEMO_ES:{
        requestdemo:{
            heading:'Regístrese para una demostración personalizada',
            subheading:"Descubra cómo la experiencia digital intuitiva y basada en datos de Credlix puede ayudarle a obtener acceso a capital de trabajo.",
            image:IMAGES.REQUESTDEMO.requestDemoImage
        },
    },
    SOLUTION_BRIEF:{
        downloadsolution:{
            heading:'Learn more about our financing solutions',
            // subheading:"Every Credlix solution is designed to help you get quick access to working capital - digitally and seamlessly.",
            image:IMAGES.DOWNLOAD_SOLUTION_BRIEF.requestDemoImage
        },
    },
    SOLUTION_BRIEF_ES:{
        downloadsolution:{
            // heading:'Contáctanos para mayor información​',
            // subheading:"En Credlix brindamos soluciones de financiamiento a la medida de la necesidad de nuestros clientes. Todo nuestro proceso es digital y sin interrupciones.​",
            image:IMAGES.DOWNLOAD_SOLUTION_BRIEF.requestDemoImage
        },
    },
    CASE_STUDY_POPUP:{
        enterprise_download:{
            heading:'Leading apparel manufacturer',
            subheading:"enabled invoicing for 70% of its vendors using the credlix invoice discounting",
            para:'Do you want to know how?',
            image:IMAGES.DOWNLOAD_CASESTUDY.leadingbrand
        },
        exporter_download:{
            heading:'One of the largest exporters',
            subheading:"in the food industry received export revenue receipts just within 36 hours with credlix.",
            para:'Do you want to know how?',
            image:IMAGES.DOWNLOAD_CASESTUDY.dcasestudy
        },
        case_study_download:{
            heading:'Gain insights from our success stories',
            subheading:"Our success stories will help you assess the business impact created by Credlix for our customers.",
            para:null,
            image:IMAGES.DOWNLOAD_CASESTUDY.dcasestudy
        },
        case_Study_formType:[
            {title:'A leading apparel manufacturer enabled 70% supplier adoption with Credlix',formType:'DownloadCSAditya'},
            {title:"Lalsai Dehy Foods received export revenue receipts in 36 hours with Credlix EXIM finance", formType:'DownloadCSVinod'},
            {title:"Lucro Plastcycle received 90% upfront export financing on its invoice value with Credlix",formType:'DownloadCSUjjwal'},
            {title:"Accord migrated its 40 suppliers to a seamless digital financing solution with Credlix",formType:'DownloadCSAccord'},
            {title:"TwigaFiber enabled 100% visibility into suppliers’ invoicing cycle with Credlix",formType:'DownloadCSTwiga'}


        ]
    },
    PARTNERSHIP_POPUP:{
        become_partner:{
            heading:'Let’s help your clients get funded',
            subheading:"As your trusted partner, we’ll help you unlock the untapped opportunities with access to the finest supply chain financing solutions.",
            // para:'Do you want to know how?',
            image:IMAGES.PARTNERSHIP.form
        }
    }

    
}